<template>
  <!-- 栏目列表 -->
  <div
    class="infoItem"
    v-infinite-scroll="loadMore"
    infinite-scroll-distance="20"
    infinite-scroll-disabled="busy"
    infinite-scroll-immediate-check="true"
  >
    <!-- 图文项目内容 -->
    <div
      class="infoItemContent"
      v-for="(item, index) in dataForm.liveList"
      :key="index"
      @click="getDetail(item.liveId)"
    >
      <!-- 图片 -->
      <div class="liveImg">
        <img class="infoItemImg" :src="item.liveCoverImg" alt="暂无图片" />
        <div class="liveStatus">
          {{
            item.liveStatus === 0
              ? '即将直播'
              : item.liveStatus === 1
              ? '直播中'
              : '历史直播'
          }}
        </div>
      </div>
      <!-- 图文项目文本 -->
      <div class="inforItemText">
        <!-- 图文项目标题 -->
        <div class="infoItemTitle">
          <p>{{ item.liveName }}</p>
        </div>
        <!-- 图文项目讲师 -->
        <div class="infoItemDes">
          <p>{{ item.liveLecturers }}</p>
        </div>
        <!-- 简介 -->
        <div class="infoItemPrice">
          <div v-if="item.orderStatus != undefined">
            <span>已购买</span>
          </div>
          <div v-else>
            <span class="price" v-if="item.livePay === 0"
              >¥&nbsp;{{ item.liveAmt.toFixed(2) }}</span
            >
            <span class="free" v-if="item.livePay === 1">免费</span>
          </div>
        </div>
        <div class="infoItemDes2" v-if="item.liveStatus === 0">
          <span>开始时间：{{ item.liveStartTime.substring(0, 19) }}</span>
        </div>
        <div class="infoItemDes2" v-if="item.liveStatus === 1">
          <span>结束时间：{{ item.liveEndTime.substring(0, 19) }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="noCourse" v-show="dataForm.liveList.length<=0">暂无相关直播，敬请期待！</div> -->
    <div
      v-if="pageIndex < dataForm.totalPage"
      style="text-align: center; font-size: 12px; color: #666; margin-top: 10px"
      @click="loadMore"
    >
      点击加载更多...
    </div>
    <div
      v-else
      style="text-align: center; font-size: 12px; color: #666; margin-top: 10px"
    >
      暂无更多直播...
    </div>
  </div>
</template>
<script>
export default {
  props: ['catId', 'catName', 'buy'],
  data() {
    return {
      dataForm: {
        currPage: 0,
        liveList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0
      },
      pageIndex: 1,
      busy: false
    }
  },
  mounted() {
    this.getLiveList()
  },
  methods: {
    // 加载更多
    loadMore() {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getLiveList()
      }
    },
    getDetail(liveId) {
      // this.$router.push('/details/' + liveId)
      // this.$router.push({
      //   path: '/details',
      //   query: {
      //     liveId: liveId,
      //   },
      // })
      const routeData = this.$router.resolve({
        path: '/details',
        query: { liveId: liveId }
      })
      window.open(routeData.href, '_blank')
    },
    // 获取指定分类直播列表
    getLiveList() {
      this.$http({
        url: '/live/live/queryList/',
        method: 'get',
        params: {
          catId: this.catId,
          page: this.pageIndex,
          limit: 10
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm.liveList = this.dataForm.liveList.concat(data.data.list)
          this.dataForm.pageSize = data.data.pageSize
          this.dataForm.totalCount = data.data.totalCount
          this.dataForm.totalPage = data.data.totalPage
          this.dataForm.currPage = data.data.currPage
        } else {
          this.dataForm.liveList = []
          this.pageIndex = 1
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.noCourse {
  text-align: center;
  padding: 20px 0;
  color: #666;
  font-size: 14px;
}
/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}
.inforItemText {
  margin-left: 2rem;
  width: 65%;
  // line-height: 35px;
}
/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
}
/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}
.infoItemContent {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid #eee;
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      font-size: 12px;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
}
/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 100px;
  height: 75px;
  border-radius: 5px;
}
/* 图文项目的内容信息--简介 */
.infoItemDes {
  // line-height: 20px;
  color: #666;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 3px 0;
}
.infoItemDes2 {
  // line-height: 15px;
  color: #666;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // margin: 5px 0;
}
.infoItemPrice {
  font-size: 14px;
  color: #999;
  padding-bottom: 5px;
  .free {
    padding: 2px;
    margin-right: 1rem;
    font-size: 12px;
    background-color: $theme-color;
    border-radius: 3px;
    color: #fff;
  }
  .price {
    margin-right: 1rem;
    color: $theme-color;
    padding: 2px;
    span {
      margin-left: 5px;
    }
  }
}
</style>
